var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RootContainer',[_vm._t("default"),(_vm.showLogo)?_c('OrbVizLogo',{staticClass:"bg-logo"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }